import React from 'react';
import { Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';

function SliderInput({ label, value, onChange, min, max, step = 0.01, tooltipText, darkMode }) {
  return (
    <Form.Group className="mb-4">
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip
            style={{
              fontSize: '13px',
              backgroundColor: darkMode ? '#333' : '#eee',
              color: darkMode ? '#fff' : '#000',
              opacity: 0.9,
              padding: '8px',
              borderRadius: '8px',
            }}
          >
            {tooltipText}
          </Tooltip>
        }
        delay={{ show: 300, hide: 100 }}
        trigger={['hover', 'focus']}
      >
        <Form.Label style={{ cursor: 'pointer' }}>
          {label}: <strong>{value}</strong>
        </Form.Label>
      </OverlayTrigger>
      <Form.Range
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Form.Group>
  );
}

function AdvancedSettings({ 
  maxLength, setMaxLength, 
  temperature, setTemperature, 
  topP, setTopP, 
  presencePenalty, setPresencePenalty, 
  frequencyPenalty, setFrequencyPenalty,
  darkMode
}) {
  return (
    <>
      {/* Max Context Length */}
      <SliderInput
        label="Max Context Length"
        value={maxLength}
        onChange={setMaxLength}
        min={100}
        max={5000}  // محدودیت جدید
        step={1}
        tooltipText="حداکثر تعداد توکن‌هایی که می‌توان به مدل فرستاد. مقدار بیشتر برای متن‌های طولانی‌تر مناسب است."
        darkMode={darkMode}
      />

      {/* Temperature و Top P */}
      <Row className="mb-3">
        <Col md={6}>
          <SliderInput
            label="Temperature"
            value={temperature}
            onChange={setTemperature}
            min={0}
            max={2}
            step={0.01}
            tooltipText="میزان خلاقیت مدل. عدد بالاتر خروجی متنوع‌تر، عدد پایین‌تر خروجی دقیق‌تر."
            darkMode={darkMode}
          />
        </Col>
        <Col md={6}>
          <SliderInput
            label="Top P"
            value={topP}
            onChange={setTopP}
            min={0}
            max={1}
            step={0.01}
            tooltipText="تعیین درصدی از توزیع احتمال واژگان که مدل بررسی کند. عدد ۱ یعنی همه واژه‌ها در نظر گرفته می‌شوند."
            darkMode={darkMode}
          />
        </Col>
      </Row>

      {/* Presence Penalty و Frequency Penalty */}
      <Row>
        <Col md={6}>
          <SliderInput
            label="Presence Penalty"
            value={presencePenalty}
            onChange={setPresencePenalty}
            min={-2}
            max={2}
            step={0.01}
            tooltipText="جریمه برای تکرار موضوعات قبلی. عدد مثبت باعث متنوع‌تر شدن پاسخ‌ها می‌شود."
            darkMode={darkMode}
          />
        </Col>
        <Col md={6}>
          <SliderInput
            label="Frequency Penalty"
            value={frequencyPenalty}
            onChange={setFrequencyPenalty}
            min={-2}
            max={2}
            step={0.01}
            tooltipText="جریمه برای تکرار واژگان مشابه. عدد مثبت باعث کاهش تکرار لغات می‌شود."
            darkMode={darkMode}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdvancedSettings;
